export const getElementDataRoot = (PageID) =>
  PageID === 'project' ? ['project', 'Settings'] : ['pages', PageID, 'Props']
